import { useEffect, useState } from "react";
import { getStringsFromDomain } from "@/utils/domainSpecific/stringsDomain";
import { getConstantsFromDomain } from "@/utils/domainSpecific/constants";
import { getImagesFromDomain } from "@/utils/domainSpecific/imageRelativePaths";

function useDomainFilePick() {
  const [hostname, setHostname] = useState("chingari");
  const [DomainStrings, setStrings] = useState(getStringsFromDomain(""));
  const [DomainConstants, setConstants] = useState(getConstantsFromDomain(""));
  const [DomainImages, setImages] = useState(getImagesFromDomain(""));

  useEffect(() => {
    let hostname = window?.location?.hostname;
    setHostname(hostname?.split(".")?.slice(-2)?.[0]);
    setStrings(getStringsFromDomain(hostname));
    setConstants(getConstantsFromDomain(hostname));
    setImages(getImagesFromDomain(hostname));
  }, []);

  return { hostname, DomainStrings, DomainConstants, DomainImages };
}

export default useDomainFilePick;
